// src/rds_ui/api/moduleApi.js
//
// Migrated off raw fetch() onto the shared axios instance in
// src/api/client.js (see projectsApi.js in this folder for why).
import { api } from "../../api/client";

const BASE = "/rds";

export async function updateModule(runId, moduleId, { name, description }) {
  try {
    const res = await api.patch(`${BASE}/generations/${runId}/modules/${moduleId}`, { name, description });
    return res.data;
  } catch {
    throw new Error("Failed to update module");
  }
}

export async function refineModule(runId, moduleId, feedback) {
  try {
    const res = await api.post(`${BASE}/generations/${runId}/modules/${moduleId}/refine`, { feedback });
    return res.data;
  } catch {
    throw new Error("Failed to refine module");
  }
}

export async function regenerateModuleArtifacts(runId, moduleId) {
  try {
    const res = await api.post(`${BASE}/generations/${runId}/modules/${moduleId}/regenerate`);
    return res.data;
  } catch {
    throw new Error("Failed to regenerate artifacts");
  }
}

export async function fetchModuleVersions(runId, moduleId) {
  try {
    const res = await api.get(`${BASE}/generations/${runId}/modules/${moduleId}/versions`);
    return res.data;
  } catch {
    throw new Error("Failed to fetch module versions");
  }
}
